import { createSelector } from '@ngrx/store';
import { cartState } from '../root';

export const getCartDeliveryAddress = createSelector(cartState, (cart) => cart.deliveryAddress);
